import React, { useState, useMemo } from 'react';
import { Space, Typography, DatePicker, Cascader } from 'antd';
import { Button, Message } from '@alifd/next';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { downloadSheet } from './util';

export default function DownloadFinancialStatement({ nestedSubjects }) {
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [timeStartAndEnd, setTimeStartAndEnd] = useState([moment(), moment()]);

  const handleDownload = () => {
    if (selectedSubjectId && timeStartAndEnd) {
      const url = `/ezcon/api/downloadFinancialLedgerExcel?subjectArray[]=${selectedSubjectId.at(
        -1
      )}&timeStart=${timeStartAndEnd[0].valueOf()}&timeEnd=${timeStartAndEnd[1].valueOf()}`;
      const exportTitle = (() => {
        let subject = {};
        if (selectedSubjectId.length === 2) {
          const parent = nestedSubjects.find(
            (item) => item._id === selectedSubjectId[0]
          );
          subject = parent.children.find(
            (item) => item._id === selectedSubjectId[1]
          );
        }
        if (selectedSubjectId.length === 1) {
          subject = nestedSubjects.find(
            (item) => item._id === selectedSubjectId[0]
          );
        }
        return `${timeStartAndEnd[0].format(
          'YYYYMM'
        )}-${timeStartAndEnd[1].format('YYYYMM')}${
          subject.subjectName
        }明細表.xlsx`;
      })();
      downloadSheet(url, exportTitle);
    } else {
      Message.error('請選擇科目及時間');
    }
  };

  const CascadeSubjects = useMemo(() => {
    const subjects = [];
    nestedSubjects.forEach((subject) => {
      const children = [];
      if (subject.children) {
        subject.children.forEach((child) => {
          if (child.activated) {
            children.push({
              value: child._id,
              label: `${child.subjectCode} ${child.subjectName}`,
            });
          }
        });
      }
      if (subject.activated) {
        subjects.push({
          value: subject._id,
          label: `${subject.subjectCode} ${subject.subjectName}`,
          children,
        });
      }
    });
    return subjects;
  }, [nestedSubjects]);

  return (
    <div>
      <Typography.Text>科目與時間範圍：</Typography.Text>
      <Space>
        <Cascader
          options={CascadeSubjects}
          onChange={(value) => {
            if (value) {
              setSelectedSubjectId(value);
            } else {
              setSelectedSubjectId(null);
            }
          }}
          placeholder="請選擇科目"
          expandTrigger="hover"
          style={{ width: '325px' }}
        />
        <DatePicker.RangePicker
          value={timeStartAndEnd}
          onChange={(value) => setTimeStartAndEnd(value)}
          locale={locale}
          disabledDate={(current) => current && current > moment().endOf('day')}
        />
        <Button onClick={handleDownload}>下載</Button>
      </Space>
    </div>
  );
}
